import Util from "./Util.js";
//
import { gsap } from "./Util.js";
import { CustomEase } from "./Util.js";

class Modal extends Util {
  constructor() {
    super();
    this.init();
  }

  init() {
    if (document.querySelectorAll(".modal-trigger").length > 0) {
      this.sizeModal();
    }
  }

  sizeModal() {
    const modal = document.querySelector(".size-modal");
    const modalTrigger = document.querySelectorAll(".modal-trigger");
    modalTrigger.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        window.SCROLL_INSTANCE.lenis.stop();
        gsap.set("body", {
          overflow: "hidden",
        });
        modal.classList.add("is-open");
        modal.querySelector(".img img").src = trigger.dataset.src;
        const img = modal.querySelector(".img img");
        img.onload = () => {
          const aspectRatio = img.naturalWidth / img.naturalHeight;
          if (0.5 > aspectRatio) {
            // console.log("max600");
            modal.querySelector(".inner").classList.add("max600");
          } else if (1 > aspectRatio) {
            // console.log("max600");
            modal.querySelector(".inner").classList.add("max600");
          } else {
            // console.log("max820");
            modal.querySelector(".inner").classList.add("max820");
          }
          // console.log(aspectRatio);

          if (img.getBoundingClientRect().height < window.innerHeight) {
            modal.querySelector(".inner").classList.add("centered");
          }
        };
      });
    });

    modal.querySelector(".bg").addEventListener("click", () => {
      modal.classList.remove("is-open");
      window.SCROLL_INSTANCE.lenis.start();
      gsap.set("body", {
        overflow: "auto",
      });
    });

    modal.querySelector(".close-btn").addEventListener("click", () => {
      modal.classList.remove("is-open");
      window.SCROLL_INSTANCE.lenis.start();
      gsap.set("body", {
        overflow: "auto",
      });
    });
  }
}

export default Modal;
